module.exports = __webpack_public_path__ + "static/media/install-2.6d3c5252.png";